module.exports = {"611024001":"城关街道","611024002":"十里铺街道","611024101":"高坝店镇","611024102":"天竺山镇","611024103":"中村镇","611024104":"银花镇","611024105":"西照川镇","611024106":"漫川关镇","611024107":"南宽坪镇","611024108":"户家塬镇","611024109":"杨地镇","611024111":"小河口镇","611024112":"色河铺镇","611024113":"板岩镇","611024116":"延坪镇","611024117":"两岭镇","611024118":"王阎镇","611024121":"法官镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611024.json
// module id = 3026
// module chunks = 0